import React from "react";
import MeetPageInsights from "./MeetPageInsights";
import MeetPageEmptyState from "./MeetPageEmptyState";

const MeetPageAnalytics = ({ enrollment, ga4 }) => {
  if (!ga4?.connected || !enrollment) {
    return (
      <section className="owner-dashboard__panel owner-dashboard__panel--signals owner-dashboard__meet-tab">
        <MeetPageEmptyState
          days={enrollment?.dateRange?.days || 30}
          variant="not-connected"
        />
        {ga4?.error && (
          <p className="owner-dashboard__error owner-dashboard__meet-empty-error">
            GA4 error: {ga4.error}
          </p>
        )}
      </section>
    );
  }

  const days = enrollment.dateRange?.days || 30;

  return (
    <section className="owner-dashboard__panel owner-dashboard__panel--signals owner-dashboard__meet-tab">
      <MeetPageInsights
        meetPageInterest={enrollment.meetPageInterest}
        days={days}
        showHeader={false}
      />
    </section>
  );
};

export default MeetPageAnalytics;
